import React from 'react';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';

class PromoTimePicker extends React.Component {
  render() {
    const {
      input,
      meta: { touched, error },
      className,
      defaultValue,
      showSecond,
      allowEmpty,
      onChangeValue,
    } = this.props;
    return (
      <div>
        <TimePicker
          {...input}
          defaultValue={defaultValue}
          className={className}
          showSecond={showSecond}
          allowEmpty={allowEmpty}
          format="HH:mm"
          onChange={onChangeValue}
        />
        {touched && error && <span>{error}</span>}
      </div>
    );
  }
}

export default PromoTimePicker;
